<template>
  <section class="timeline-section">
    <div class="timeline-container">
      <div class="timeline-wrapper">
        <div v-for="(item, index) in filteredApproverList" :key="index" class="timeline-item" :title="item.comment">
          <div class="timeline-timestamp">
            <span class="timeline-name">{{ item.name }}</span>
            <span v-if="showUserTypeAndDate" class="timeline-con-type">{{ formatUserType(item.userType) }}</span>
          </div>
          <div class="timeline-status" :class="{ 'timeline-status--pending': item.status === 'Pending' }">
            <span>{{ item.status }}</span>
            <span v-if="showUserTypeAndDate && item.status !== 'Pending' && item.modifiedOn" class="timeline-modified-on">
              {{ formatDate(item.modifiedOn) }}
            </span>

            <div v-if="item.comment" class="timeline-comment">
              {{ item.comment }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ApprovalTimeline',
  props: {
    approverList: {
      type: Array,
      default: () => [],
    },
    applicationStatus: {
      type: String,
      default: '',
    },
    schoolId: {
      type: String,
      default: '',
    },
  },
  computed: {
    showUserTypeAndDate() {
      return ['SCH201700000431', 'SCH201300000254'].includes(this.schoolId)
    },
    filteredApproverList() {
      return this.approverList.filter(approver => approver.level < 99 || this.applicationStatus === 'Rejected' || this.applicationStatus === 'Closed')
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      return moment(date, 'DD/MM/YYYY HH:mm:ss').format('DD MMM YYYY')
    },
    formatUserType(userType) {
      return userType.join(', ')
    },
  },
}
</script>

<style scoped>
.timeline-section {
  padding: 10px 0;
  width: 100%;
  margin-bottom: 20px;
}

.timeline-container {
  width: 95%;
  margin: auto;
  overflow-x: auto;
  overflow-y: hidden;
}

.timeline-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  min-width: 100%;
}

.timeline-container::-webkit-scrollbar-track {
  background: #f3f1f1;
}

.timeline-container::-webkit-scrollbar {
  height: 8px;
}

.timeline-container::-webkit-scrollbar-thumb {
  background: #7442ff !important;
  border-radius: 4px;
}

.timeline-item {
  text-align: center;
  font-size: 12px;
  flex-basis: 33%;
  position: relative;
  flex-shrink: 0;
}

.timeline-timestamp {
  margin: auto auto 5px;
  padding: 0 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.timeline-name {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.timeline-status {
  padding: 16px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  border-top: 3px solid #426dff;
  position: relative;
  transition: all 200ms ease-in;
  background: #f8f9fa;
  border-radius: 0 0 8px 8px;
}

.timeline-status--pending {
  border-top: 3px solid #ffc107;
  background: #f8f9fa;
}

.timeline-status span {
  font-weight: 500;
  color: #333;
}

.timeline-status span:before {
  content: '';
  width: 10px;
  height: 10px;
  background-color: #426dff;
  border-radius: 50%;
  border: 2px solid #426dff;
  position: absolute;
  left: 50%;
  top: -6px;
  transform: translateX(-50%);
  transition: all 200ms ease-in;
}

.timeline-status--pending span:before {
  width: 10px;
  height: 10px;
  background-color: #ffc107;
  border: 2px solid #ffc107;
  top: -6px;
}

.timeline-con-type {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
}

.timeline-modified-on {
  font-size: 11px;
  color: #888;
}

.timeline-comment {
  font-size: 0.9em;
  line-height: 1.2;
  color: #666;
  font-style: italic;
  word-wrap: break-word;
  text-align: center;
}

@media (max-width: 768px) {
  .timeline-item {
    min-width: 150px;
    font-size: 11px;
  }

  .timeline-name {
    font-size: 12px;
  }

  .timeline-comment {
    font-size: 10px;
    max-width: 130px;
    padding: 4px 6px;
  }
}
</style>
